import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Tooltip, OverlayTrigger, Badge ,Modal } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import uthappam from '../../../../images/items/podi_uthappam.png';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';

const ReWorkView = ({ show, onClose, data }) => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const tableRef = useRef(null);

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    // pageLength: 25,
                    "ordering": false,
                    scrollY: "250px",
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Rework - {data.item_name}</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className='row mb-2'>
                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <div className="d-flex align-items-start justify-content-start gap-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={uthappam} className='border rounded px-1 py-0'>
                                        <img src={uthappam} alt="Basmathi Rice" className='cursor-pointer w-50px h-50px' />
                                    </div>
                                </LightGallery>
                                <div>
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Category</span></Tooltip>} >
                                        <label className='text-black font-w500 fs-5'>Rice Based Food</label>
                                    </OverlayTrigger>
                                    <div className="d-block">
                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Sub Category</span></Tooltip>} >
                                            <div className="fs-7 text-black">{data.item_name}</div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div className='col-lg-4 d-flex flex-column pt-1'>
                            <label className="fs-7 text-black mb-0 font-w500">Items Schedule</label>
                            <label className="fs-6 text-danger mb-0 font-w500">{data.schedule_name}</label>
                        </div>

                        <div className='col-lg-4 d-flex flex-column pt-1'>
                            <label className="fs-7 text-black mb-0 font-w500">Date</label>
                            <label className="fs-6 text-danger mb-0 font-w500">17-Sept-2025	</label>
                        </div>
                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <label className="fs-7 text-black mb-0 font-w500">Total Quantity</label>
                            <span>
                                <Badge as="a" href="" bg="badge" className='badge-outline-danger fw-bold fs-6'> {data.total_quantity} </Badge>
                            </span>
                        </div>


                        
                        <div className='col-lg-4 d-flex flex-column mb-4'>
                            <label className="fs-7 text-black mb-0 font-w500">Total Raw Materials Needed</label>
                            <span>
                                <Badge as="a" href="" bg="badge" className='badge-outline-danger fw-bold fs-6'> 07 </Badge>
                            </span>
                        </div>
                        <div className='col-lg-4 d-flex flex-column pt-1'>
                            <label className="fs-7 text-black mb-0 font-w500">Production Time</label>
                            <label className="fs-6 text-danger mb-0 font-w500">02h 30m 00s</label>
                        </div>
                        <div className='col-lg-12 d-flex flex-column mb-4'>
                             <label className="fs-7 text-black mb-0 font-w500">Reason</label>
                            <label className="fs-6 text-black mb-0 font-w500">&emsp;&emsp;{data.rework_reason? data.rework_reason : '-'}</label>
                        </div>
                        
                    </div>

                </div>
            </div>
        </Modal>
    );
};

export default ReWorkView;